export async function retireAdvertisingWorker() {
  if (!globalThis.navigator?.serviceWorker?.getRegistrations) return
  try {
    for (const registration of await navigator.serviceWorker.getRegistrations()) {
      const retired = [registration.active, registration.waiting, registration.installing].filter(Boolean).some(worker => {
        const url = new URL(worker.scriptURL, location.origin)
        return url.origin === location.origin && url.pathname === '/sw.js'
      })
      if (retired) await registration.unregister()
    }
  } catch { /* Browsers without service-worker access still run the application. */ }
}
